import { pageIds } from './constants'

function byId (id) {
  return document.getElementById(id)
}

function byClass (className) {
  return document.getElementsByClassName(className)[0]
}

function setStyle (el, styles) {
  if (!el) return
  for (const styleKey in styles) {
    el.style[styleKey] = styles[styleKey]
  }
}

function show (el, display) {
  if (display) {
    setStyle(el, { display: '' })
  } else {
    setStyle(el, { visibility: 'visible' })
  }
}

function hide (el, display) {
  if (display) {
    setStyle(el, { display: 'none' })
  } else {
    setStyle(el, { visibility: 'hidden' })
  }
}

/**
 * 获取可视区域高度
 */
function getViewPortHeight () {
  return window.innerHeight
      || document.documentElement.clientHeight
      || document.body.clientHeight
}

/**
 * 判断元素是否在可视区域
 */
function isInViewPort (el) {
  if (!el) return false
  const viewPortHeight = getViewPortHeight()
  const top = el.getBoundingClientRect()
      && el.getBoundingClientRect().top
  return top < viewPortHeight
}

/**
 * 计算2个元素左上角点的位置差
 * @returns object { x, y }
 */
function calcPositionDiff (target, source) {
  if (!source || !target) return null
  const sourcePos = source.getBoundingClientRect()
  const targetPos = target.getBoundingClientRect()
  return {
    x: sourcePos.left - targetPos.left,
    y: sourcePos.top - targetPos.top
  }
}

/**
 * 从页面上删除 DOM 节点
 */
function removeElement (el) {
  if (!el) return
  el.parentElement.removeChild(el)
}

/**
 * 获取当前页 ID
 */
function getCurrentPage () {
  for (let i = pageIds.length - 1; i > -1; i--) {
    if (isInViewPort(byId(pageIds[i]))) {
      return pageIds[i]
    }
  }
}

/**
 * 平滑滚动
 */
let scrolling = false
function smoothScrollBy (top, duration) {
  if (scrolling) return
  scrolling = true
  let requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame
  let startTime = new Date().getTime()
  let startTop = getScrollY()
  function scroll () {
    let currentTime = new Date().getTime()
    if (currentTime <= startTime + duration + 100) {
      let passedTime = currentTime - startTime
      if (passedTime > duration) passedTime = duration
      window.scrollTo(0, startTop + sin(passedTime, duration, top))
      requestAnimationFrame(scroll)
    } else {
      scrolling = false
    }
  }
  requestAnimationFrame(scroll)
}

function getScrollY () {
  return window.scrollY || window.pageYOffset
}

/**
 * 经过点 (0, 0) 且 1/4 周期点在 (a, b) 的 sin 函数，返回 x 对应的 y 值
 */
function sin (x, a, b) {
  return b * Math.sin(x * Math.PI / (a * 2))
}

/**
 * 获取地址栏参数
 */
function getQueryString (name) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`)
  const r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return unescape(r[2])
  }
  return null
}

/**
 * 取得介于 min 到 max 之间的一个随机整数
 * @returns min（包含）～ max（包含）之间的数字
 */
function randomInt (min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

/**
 * 判断手机端
 */
function isMobile () {
  return document.body.clientWidth <= 500
}

function getBrowser () {
  const ua = navigator.userAgent
  if (ua.indexOf("rv:11.0") > -1) {
    return 'ie'
  } else if (ua.indexOf("Edge") > -1) {
    // Chromium 版本的 Edge 的 UA 为 "Edg"，无需担心误判
    return 'edge'
  } else if (ua.indexOf("Firefox") > -1) {
    return 'firefox'
  } else if (ua.indexOf("Safari") > -1 && ua.indexOf("Chrome") == -1) {
    return 'safari'
  } else if (ua.indexOf("iPhone") > -1 || ua.indexOf("iPad") > -1) {
    return 'safari'
  } else if (ua.indexOf("Chrome") > -1 && ua.indexOf("Safari") > -1) {
    return 'chrome'
  }
}

function calcPageScrollPercent(id) {
  const pageEl = byId(id).parentElement
  const currentTopPos = -pageEl.getBoundingClientRect().top
  const scrollHeight = pageEl.scrollHeight - getViewPortHeight()
  let percent = currentTopPos / scrollHeight
  if (percent < 0) {
    percent = 0
  } else if (percent > 1) {
    percent = 1
  }
  return percent
}

export {
  byId,
  byClass,
  setStyle,
  show,
  hide,
  getViewPortHeight,
  calcPositionDiff,
  removeElement,
  getCurrentPage,
  smoothScrollBy,
  getScrollY,
  getQueryString,
  randomInt,
  isMobile,
  getBrowser,
  calcPageScrollPercent
}
